import request from 'oc-request'
export default new (class Cart {
    constructor() {
        this.cartItem = "_cart-item"
        this.cartItem = "_cart-item"
        this.cartAddBtn = "_cart-add"
        this.cartRemoveBtn = "_cart-remove"
        this.sReorderSelector = '_cart-reorder';

        this.handler()
    }

    handler() {
        let _this = this;
        document.body.addEventListener("click", function (e) {
            //добавление товара к корзину страница категории, слайдер
            if (e.target && e.target.classList.contains(`${_this.cartAddBtn}`)) {
                e.preventDefault();
                let obEvent = e;
                //offer_id из карточки товара
                let offer_id = obEvent.target.getAttribute('data-offer-id');
                if(offer_id == undefined) {
                    offer_id = obEvent.target.closest(`.${_this.cartAddBtn}`).getAttribute('data-offer-id');
                }
                //offer_id из детальной страницы товара
                if(offer_id == undefined) {
                    document.querySelector(`._product-detail-wrap .${_this.cartAddBtn}`).classList.add('_preloader');//прелоадер для кнопки для детальной старницы
                    offer_id = document.querySelector('#offer-id .select__input').value;
                }
                let data = {
                    'cart': [
                        {'offer_id': offer_id, 'quantity': 1}
                    ]
                };
                _this.cartAdd(data, offer_id);
            }

            //удаление товара из корзины страница корзина
            if (e.target && (e.target.classList.contains(`${_this.cartRemoveBtn}`) || e.target.closest(`.${_this.cartRemoveBtn}`))) {
                e.preventDefault();
                let obEvent = e;
                let offer_id = obEvent.target.getAttribute('data-offer-id');
                if(offer_id == undefined) {
                    offer_id = obEvent.target.closest(`.${_this.cartRemoveBtn}`).getAttribute('data-offer-id');
                }
                let data = {
                    'cart': [offer_id]
                };
                _this.cartRemove(data);
            }

            //повторить заказ
            if (e.target && e.target.classList.contains(`${_this.sReorderSelector}`)) {
                e.preventDefault();
                let obEvent = e;
                _this.reorder(obEvent.target.id);
            }
        });
    }

    reorder(sId) {
        request.sendData('StsCart::onReorder', {
            data: {
                secret_key: sId,
            },
            success: function(obData) {
                if (obData.status) {
                    location.href = '/cart';
                }
            }
        })
    }

    //добавление товара в корзину
    cartAdd(data, offer_id = null) {
        let _this = this;
        if(document.querySelector('#_cart-list')) {
            document.querySelector('#_cart-list').classList.add('_preloader');
        }
        if(document.querySelector(`.${_this.cartAddBtn}[data-offer-id="${offer_id}"]`)) {
            document.querySelector(`.${_this.cartAddBtn}[data-offer-id="${offer_id}"]`).classList.add('_preloader');
        }

        request.sendData('StsCart::onAdd', {
            'data': data,
            'update': {
                'cart/cart-list': '#_cart-list',
                'header/cart': '._cart-qualityHeader',
                'header/cart-scroll': '._cart-qualityHeader-scroll'
            },
            complete: function() {
                if(document.querySelector('#_cart-list')) {
                    document.querySelector('#_cart-list').classList.remove('_preloader');
                }
                if(document.querySelector(`.${_this.cartAddBtn}[data-offer-id="${offer_id}"]`)) {
                    document.querySelector(`.${_this.cartAddBtn}[data-offer-id="${offer_id}"]`).classList.remove('_preloader');
                }
                if(document.querySelector(`._product-detail-wrap .${_this.cartAddBtn}`)) {
                    document.querySelector(`._product-detail-wrap .${_this.cartAddBtn}`).classList.remove('_preloader'); //прелоадер для кнопки для детальной старницы
                }
            }
        });
    }
    //удаление товара из корзины
    cartRemove(data) {
        if(document.querySelector('#_cart-list')) {
            document.querySelector('#_cart-list').classList.add('_preloader');
        }

        request.sendData('StsCart::onRemove', {
            'data': data,
            'update': {
                'cart/cart-list': '#_cart-list',
                'header/cart': '._cart-qualityHeader',
                'header/cart-scroll': '._cart-qualityHeader-scroll'
            },
            complete: function() {
                if(document.querySelector('#_cart-list')) {
                    document.querySelector('#_cart-list').classList.remove('_preloader');
                }
            }
        });
    }
    //обновление позиции корзины
    cartUpdate() {
        if(document.querySelector('#_cart-list')) {
            document.querySelector('#_cart-list').classList.add('_preloader');
        }

        let data = {'cart': []};
        document.querySelectorAll(`.${this.cartItem}`).forEach((element) => {
            let id = element.getAttribute('data-id')
            let offer_id = element.getAttribute('data-offer-id')
            let quantity = element.querySelector('._input-plus-minus').value
            data['cart'].push({'id': id, 'offer_id': offer_id, 'quantity': quantity});
        });

        request.sendData('StsCart::onUpdate', {
            'data': data,
            'update': {
                'cart/cart-list': '#_cart-list',
                'header/cart': '._cart-qualityHeader',
                'header/cart-scroll': '._cart-qualityHeader-scroll'
            },
            complete: function() {
                if(document.querySelector('#_cart-list')) {
                    document.querySelector('#_cart-list').classList.remove('_preloader');
                }
            }
        });
    }
})()
